import { render, staticRenderFns } from "./PchPurchaseCreditNoteUpdate.vue?vue&type=template&id=0bc0c708&lang=pug&"
import script from "./PchPurchaseCreditNoteUpdate.vue?vue&type=script&lang=js&"
export * from "./PchPurchaseCreditNoteUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchPurchaseCreditNoteUpdate.vue"
export default component.exports